<template>
  <v-container
    id="room-manage-view"
    fluid
    tag="section"
  >
    <v-row>
      <v-col
        md="4"
        cols="12"
      >
        <!-- Treeview -->
        <material-card
          title="건물 정보"
          color="primary"
          icon="mdi-office-building"
          icon-small
        >
          <v-card>
            <v-card-text>
              <v-treeview
                v-if="treeItems.length > 0"
                item-key="_id"
                rounded
                activatable
                return-object
                selection-type="leaf"
                :open.sync="open"
                :active.sync="active"
                :items="treeItems"
                @update:active="updateActive"
              >
                <template v-slot:prepend="{ item }">
                  <v-icon
                    v-text="`mdi-${item.children ? 'office-building' : 'floor-plan'}`"
                  />
                </template>
              </v-treeview>
              <v-alert
                v-else
                border="right"
                colored-border
                type="error"
                elevation="2"
              >
                등록된 건물이 없습니다. 건물을 추가해주세요.
              </v-alert>
              <v-row
                justify="center"
              >
                <v-col
                  cols="auto"
                >
                  <v-btn
                    v-if="active.length < 1"
                    outlined
                    color="green"
                    class="mr-2"
                    @click="addBuilding"
                  >
                    <v-icon>
                      mdi-plus
                    </v-icon>
                    건물추가
                  </v-btn>
                  <v-btn
                    v-if="active[0] && active[0].children"
                    outlined
                    color="orange"
                    class="mr-2"
                    @click="editBuilding"
                  >
                    <v-icon>
                      mdi-pencil
                    </v-icon>
                    건물수정
                  </v-btn>
                  <v-btn
                    v-if="active[0] && active[0].children"
                    outlined
                    color="error"
                    class="mr-2"
                    @click="deleteBuilding"
                  >
                    <v-icon>
                      mdi-trash-can-outline
                    </v-icon>
                    건물삭제
                  </v-btn>
                  <v-btn
                    v-if="active[0] && active[0].children"
                    outlined
                    color="green"
                    class="mr-2"
                    @click="addType"
                  >
                    <v-icon>
                      mdi-plus
                    </v-icon>
                    유형추가
                  </v-btn>
                  <v-btn
                    v-if="active[0] && !active[0].children"
                    outlined
                    color="orange"
                    class="mr-2"
                    @click="editType"
                  >
                    <v-icon>
                      mdi-pencil
                    </v-icon>
                    유형수정
                  </v-btn>
                  <v-btn
                    v-if="active[0] && !active[0].children"
                    outlined
                    color="error"
                    class="mr-2"
                    @click="deleteType"
                  >
                    <v-icon>
                      mdi-trash-can-outline
                    </v-icon>
                    유형삭제
                  </v-btn>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </material-card>
      </v-col>
      <v-col
        md="8"
        cols="12"
      >
        <!-- Datatables -->
        <material-card
          :title="roomTitle"
          color="primary"
          icon="mdi-door-open"
          icon-small
        >
          <v-btn
            v-if="active.length > 0 && !active[0].children"
            slot="actions"
            outlined
            color="primary"
            @click="addRoom"
          >
            <v-icon>mdi-plus</v-icon>&nbsp;회의실 추가
          </v-btn>
          <!-- <v-row>
            <v-col
              cols="12"
              align="right"
            >
              <v-btn
                outlined
                color="primary"
              >
                <v-icon>
                  mdi-plus
                </v-icon>
                회의실 추가
              </v-btn>
            </v-col>
          </v-row> -->
          <v-row>
            <v-col>
              <!-- Datatables -->
              <v-data-table
                :headers="headers"
                :items="filteredRooms"
                :loading="loading"
              >
                <template v-slot:item.isUseApprove="{ item }">
                  {{ item.isUseApprove ? '사용' : '-' }}
                </template>

                <template v-slot:item.isPublic="{ item }">
                  {{ item.isPublic ? '공용' : '-' }}
                </template>

                <template v-slot:item.actions="{ item }">
                  <v-icon
                    medium
                    class="mr-2"
                    color="green"
                    @click="editRoom(item)"
                  >
                    mdi-pencil
                  </v-icon>
                  <v-icon
                    medium
                    color="error"
                    @click="deleteRoom(item)"
                  >
                    mdi-delete
                  </v-icon>
                </template>
              </v-data-table>
            </v-col>
          </v-row>
        </material-card>
      </v-col>
    </v-row>
    <!-- 건물 dialog -->
    <custom-dialog
      :title="buildingDialog.title"
      :is-edit="buildingDialog.isEdit"
      :dialog="buildingDialog.dialog"
      :to-parent="buildingDialogClose"
    >
      <div slot="content">
        <v-form v-model="buildingDialog.isFormValid">
          <v-row
            justify="center"
            align="center"
          >
            <v-col
              cols="12"
            >
              <v-text-field
                v-model="buildingInfo.name"
                prepend-inner-icon="mdi-office-building"
                dense
                label="건물명"
                outlined
                :rules="[rules.required]"
              />
            </v-col>
          </v-row>
        </v-form>
      </div>
    </custom-dialog>
    <!-- 유형 dialog -->
    <custom-dialog
      :title="typeDialog.title"
      :is-edit="typeDialog.isEdit"
      :dialog="typeDialog.dialog"
      :to-parent="typeDialogClose"
    >
      <div slot="content">
        <v-form v-model="typeDialog.isFormValid">
          <v-row>
            <v-col cols="12">
              <v-text-field
                v-model="typeInfo.name"
                prepend-inner-icon="mdi-floor-plan"
                dense
                hide-details
                label="유형명"
                outlined
                :rules="[rules.required]"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-text-field
                v-model="typeInfo.contact"
                prepend-inner-icon="mdi-contacts"
                dense
                hide-details
                label="담당자 연락처"
                outlined
                :rules="[rules.required]"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-text-field
                v-model="typeInfo.description"
                prepend-inner-icon="mdi-information-outline"
                dense
                hide-details
                label="유형 설명"
                outlined
                :rules="[rules.required]"
              />
            </v-col>
          </v-row>
        </v-form>
      </div>
    </custom-dialog>
    <!-- 회의실 dialog -->
    <custom-dialog
      :title="roomDialog.title"
      :is-edit="roomDialog.isEdit"
      :dialog="roomDialog.dialog"
      :to-parent="roomDialogClose"
      :max-width="500"
    >
      <div slot="content">
        <v-form v-model="roomDialog.isFormValid">
          <v-row>
            <v-col cols="12">
              <v-text-field
                v-model="roomInfo.name"
                prepend-inner-icon="mdi-door-open"
                dense
                hide-details
                label="회의실명"
                outlined
                :rules="[rules.required]"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-text-field
                v-model="roomInfo.capacity"
                prepend-inner-icon="mdi-account-group"
                dense
                hide-details
                type="number"
                label="수용 인원"
                outlined
                :rules="[rules.required, rules.number]"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-combobox
                v-model="roomInfo.roomManager"
                label="회의실 관리자"
                return-object
                hide-details
                outlined
                chips
                item-text="displayFullName"
                item-value="email"
                :items="peopleRoom"
                :search-input.sync="searchRoomManager"
                prepend-inner-icon="mdi-account-key"
                :rules="[rules.required]"
              >
                <template v-slot:selection="{ attrs, item, parent, selected }">
                  <v-chip
                    class="chip--select-multi"
                    close
                    v-bind="attrs"
                    dark
                    color="success"
                    @keydown.enter.prevent
                    :input-value="selected"
                    @input="parent.selectItem(item)"
                    @click:close="chipClose('admin' ,item)"
                  >
                    <v-avatar>
                      <v-icon blue>
                        mdi-account-circle
                      </v-icon>
                    </v-avatar>
                    <span class="white--text">
                      {{ item.displayFullName
                      ? item.displayFullName
                      : item.username
                        ? item.username
                        : item.displayName }}
                    </span>
                  </v-chip>
                </template>
                <template
                  slot="item"
                  slot-scope="data"
                >
                  <v-list-item-icon>
                    <v-icon blue>
                      mdi-account-circle
                    </v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title
                      v-html="data.item.displayFullName
                        ? data.item.displayFullName
                        : data.item.username + '/' + data.item.department + '/' + data.item.title"
                    />
                    <v-list-item-subtitle v-html="data.item.email" />
                  </v-list-item-content>
                </template>
              </v-combobox>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-combobox
                v-model="roomInfo.reserveManagers"
                label="회의실 예약 관리자"
                multiple
                return-object
                hide-details
                outlined
                chips
                item-text="displayFullName"
                item-value="email"
                :items="peopleReserve"
                :search-input.sync="searchReserveManagers"
                prepend-inner-icon="mdi-account-multiple-check"
                @change="multiSelectChipChange('userList')"
              >
                <template v-slot:selection="{ attrs, item, parent, selected }">
                  <v-chip
                    class="chip--select-multi"
                    close
                    v-bind="attrs"
                    dark
                    color="success"
                    :input-value="selected"
                    @input="parent.selectItem(item)"
                    @click:close="chipClose('reserve-admin' ,item)"
                  >
                    <v-avatar>
                      <v-icon blue>
                        mdi-account-circle
                      </v-icon>
                    </v-avatar>
                    <span class="white--text">
                      {{ item.displayFullName
                        ? item.displayFullName
                        : item.username
                          ? item.username
                          : item.displayName }}
                    </span>
                  </v-chip>
                </template>
                <template
                  slot="item"
                  slot-scope="data"
                >
                  <v-list-item-icon>
                    <v-icon blue>
                      mdi-account-circle
                    </v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title
                      v-html="data.item.displayFullName
                        ? data.item.displayFullName
                        : data.item.username + '/' + data.item.department + '/' + data.item.title"
                    />
                    <v-list-item-subtitle v-html="data.item.email" />
                  </v-list-item-content>
                </template>
              </v-combobox>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-text-field
                v-model="roomInfo.items"
                prepend-inner-icon="mdi-projector"
                dense
                hide-details
                label="장비"
                outlined
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-text-field
                v-model="roomInfo.description"
                prepend-inner-icon="mdi-information-outline"
                dense
                hide-details
                label="설명"
                outlined
              />
            </v-col>
          </v-row>
          <v-row style="margin-top: -20px;">
            <v-col cols="12">
              <v-checkbox
                v-model="roomInfo.isUseApprove"
                label="승인 사용 여부"
                hide-details
                dense
              />
            </v-col>
          </v-row>
          <v-row style="margin-top: -20px;">
            <v-col cols="12">
              <v-checkbox
                v-model="roomInfo.isPublic"
                label="공용 여부"
                hide-details
                dense
              />
            </v-col>
          </v-row>
        </v-form>
      </div>
    </custom-dialog>
    <!-- confirm dialog -->
    <confirm-dialog
      :title="confirmDialog.title"
      :content="confirmDialog.content"
      :dialog="confirmDialog.dialog"
      :to-parent="confirmDialogClose"
    />
  </v-container>
</template>

<script>
  import { isValidateChcker, snackbarOpen } from '@/util/helpers'
  import { get } from 'vuex-pathify'
  import debounce from 'lodash.debounce'

  export default {

    data: () => ({
      loading: false,
      buildingDialog: {
        dialog: false,
        isEdit: false,
        title: '',
        isFormValid: false,
      },
      typeDialog: {
        dialog: false,
        isEdit: false,
        title: '',
        isFormValid: false,
      },
      roomDialog: {
        dialog: false,
        isEdit: false,
        title: '',
        isFormValid: false,
      },
      confirmDialog: {
        title: '',
        content: '',
        dialog: false,
        mode: null,
      },
      buildingInfo: {
        _id: '',
        name: '',
      },
      typeInfo: {
        _id: '',
        name: '',
        buildingId: '',
        contact: '',
        description: '',
      },
      roomInfo: {
        _id: '',
        name: '',
        buildingId: '',
        typeId: '',
        capacity: '',
        isUseApprove: false,
        roomManager: null,
        reserveManagers: [],
        description: '',
        items: '',
        isPublic: false,
      },
      defaultBuildingInfo: null,
      defaultTypeInfo: null,
      defaultRoomInfo: null,
      roomTitle: '유형을 선택하세요',
      active: [],
      open: [],
      headers: [
        { sortable: false, text: '건물명', value: 'buildingName', align: 'center', class: 'primary--text' },
        { sortable: false, text: '유형', value: 'typeName', align: 'center', class: 'primary--text' },
        { sortable: false, text: '회의실', value: 'name', align: 'center', class: 'primary--text' },
        { sortable: false, text: '수용인원', value: 'capacity', align: 'center', class: 'primary--text' },
        { sortable: false, text: '승인 여부', value: 'isUseApprove', align: 'center', class: 'primary--text' },
        { sortable: false, text: '공용 여부', value: 'isPublic', align: 'center', class: 'primary--text' },
        { sortable: false, text: '수정 / 삭제', value: 'actions', align: 'center', class: 'primary--text' },
      ],
      treeItems: [],
      rules: {
        required: isValidateChcker.required,
        number: isValidateChcker.number,
      },
      rooms: [],
      filteredRooms: [],
      searchRoomManager: null,
      searchReserveManagers: null,
      peopleRoom: [],
      peopleReserve: [],
      lastSearchPeople: [],
    }),

    computed: {
      info: get('user/info'),
    },

    watch: {
      searchRoomManager: {
        handler (val) {
          this.searchPeople('room', val)
        },
      },
      searchReserveManagers: {
        handler (val) {
          this.searchPeople('reserve', val)
        },
      },
      'roomInfo.reserveManagers': {
        handler (val) {
          // console.log('handler val :: ' + JSON.stringify(val))
          if (val === undefined) return

          const keyword = this.roomInfo.reserveManagers[val.length - 1]

          if (typeof keyword === 'string') {
            if (this.lastSearchPeople.length > 0) {
              // console.log(this.lastSearchPeople[0].email)
              const findData = this.roomInfo.reserveManagers.find(x => x.email === this.lastSearchPeople[0].email)
              // console.log(findData)
              if (!findData) {
                this.roomInfo.reserveManagers[val.length - 1] = this.lastSearchPeople[0]
              } else {
                this.roomInfo.reserveManagers.pop()
              }
            }
          }
        },
      },
    },

    created () {
      this.heading = this.$t('page.meeting-list')
      this.defaultBuildingInfo = { ...this.buildingInfo }
      this.defaultTypeInfo = { ...this.typeInfo }
      this.defaultRoomInfo = { ...this.roomInfo }
    },

    async mounted () {
      await this.getTreeView()
      // await this.getRooms()
    },

    methods: {
      async getTreeView () {
        this.$http.get('/api/v1/buildings/trees').then(response => {
          this.treeItems = response.data
          if (this.treeItems.length < 1) {
            this.active = []
          }
          this.open = this.treeItems.filter(x => x.children)
        }).catch(error => {
          console.log(error)
        })
      },
      async getRooms () {
        this.loading = true
        const params = {
          typeId: this.typeInfo._id,
        }
        await this.$http.get('/api/v1/rooms', { params: params }).then(response => {
          this.rooms = response.data
          this.filteredRooms = this.rooms.filter(room => room.typeId === params.typeId)
        }).catch(error => {
          console.log(error)
        })
        this.loading = false
      },
      async updateActive (item) {
        this.loading = true
        const type = item[0]
        if (type && !type.children) {
          // type 선택
          this.roomTitle = `${type.name} 회의실`
          this.filteredRooms = this.rooms.filter(room => String(room.typeId) === String(type._id))
          this.typeInfo = type
          await this.getRooms()
        } else {
          // building 선택
          this.roomTitle = '유형을 선택하세요'
          this.filteredRooms = []
          if (type) {
            this.buildingInfo = type
          }
        }
        this.loading = false
      },
      addBuilding () {
        this.buildingInfo = { ...this.defaultBuildingInfo }
        this.buildingDialog.dialog = true
        this.buildingDialog.isEdit = false
        this.buildingDialog.title = '건물 추가'
      },
      editBuilding () {
        this.buildingDialog.dialog = true
        this.buildingDialog.isEdit = true
        this.buildingDialog.title = '건물 수정'
      },
      deleteBuilding () {
        this.confirmDialog.dialog = true
        this.confirmDialog.title = '건물 삭제'
        this.confirmDialog.content = '선택하신 건물을 삭제하시겠습니까? 삭제하면 건물에 속한 유형과 회의실도 모두 삭제됩니다.'
        this.confirmDialog.mode = 'building'
      },
      addType () {
        this.typeInfo = { ...this.defaultTypeInfo }
        this.typeDialog.dialog = true
        this.typeDialog.isEdit = false
        this.typeDialog.title = '유형 추가'
      },
      editType () {
        this.typeDialog.dialog = true
        this.typeDialog.isEdit = true
        this.typeDialog.title = '유형 수정'
      },
      deleteType () {
        this.confirmDialog.dialog = true
        this.confirmDialog.title = '유형 삭제'
        this.confirmDialog.content = '선택하신 유형을 삭제하시겠습니까? 삭제하면 유형에 속한 회의실도 모두 삭제됩니다.'
        this.confirmDialog.mode = 'type'
      },
      addRoom () {
        this.roomInfo = { ...this.defaultRoomInfo }
        this.roomDialog.dialog = true
        this.roomDialog.isEdit = false
        this.roomDialog.title = '회의실 추가'
      },
      editRoom (item) {
        this.roomInfo = { ...item }
        this.roomDialog.dialog = true
        this.roomDialog.isEdit = true
        this.roomDialog.title = '회의실 수정'
      },
      deleteRoom (item) {
        this.roomInfo = { ...item }
        this.confirmDialog.dialog = true
        this.confirmDialog.title = '회의실 삭제'
        this.confirmDialog.content = '선택하신 회의실을 삭제하시겠습니까?'
        this.confirmDialog.mode = 'room'
      },
      async buildingDialogClose (result) {
        if (result !== 'cancel') {
          if (!this.buildingDialog.isFormValid) return
        }

        if (result === 'save') {
          await this.$http.post('/api/v1/buildings', this.buildingInfo).then(response => {
            const building = response.data
            snackbarOpen('success', `${building.name} 건물이 추가되었습니다.`, 'success')
          }).catch(error => {
            console.log(error)
          })
        } else if (result === 'edit') {
          await this.$http.put('/api/v1/buildings', this.buildingInfo).then(response => {
            snackbarOpen('info', `${this.buildingInfo.name} 건물이 수정되었습니다.`, 'info')
          }).catch(error => {
            console.log(error)
          })
        }

        await this.getTreeView()
        this.buildingDialog.dialog = false
      },
      async typeDialogClose (result) {
        if (result !== 'cancel') {
          if (!this.typeDialog.isFormValid) return
        }

        if (result === 'save') {
          // save
          this.typeInfo.buildingId = this.buildingInfo._id
          this.typeInfo.buildingName = this.buildingInfo.name
          await this.$http.post('/api/v1/types', this.typeInfo).then(response => {
            const type = response.data
            snackbarOpen('success', `${type.name} 유형이 추가되었습니다.`, 'success')
          }).catch(error => {
            console.log(error)
          })
        } else if (result === 'edit') {
          // edit
          await this.$http.put('/api/v1/types', this.typeInfo).then(response => {
            snackbarOpen('info', `${this.typeInfo.name} 유형이 수정되었습니다.`, 'info')
          }).catch(error => {
            console.log(error)
          })
        }

        await this.getTreeView()
        this.typeDialog.dialog = false
      },
      async roomDialogClose (result) {
        if (result !== 'cancel') {
          if (!this.roomDialog.isFormValid) return
        }

        if (result === 'save') {
          if (typeof this.roomInfo.roomManager === 'object') {
            // save
            this.roomInfo.buildingId = this.typeInfo.buildingId
            this.roomInfo.buildingName = this.typeInfo.buildingName
            this.roomInfo.typeId = this.typeInfo._id
            this.roomInfo.typeName = this.typeInfo.name

            await this.$http.post('/api/v1/rooms', this.roomInfo).then(async response => {
              await this.getRooms()
              const room = response.data
              snackbarOpen('success', `${room.name} 회의실이 추가되었습니다.`, 'success')
            }).catch(error => {
              console.log(error)
            })
          } else {
            snackbarOpen('pink', '잘못된 회의실 관리자 입니다.', 'error')
            return
          }
        }

        if (result === 'edit') {
          if (typeof this.roomInfo.roomManager === 'object') {
            await this.$http.put('/api/v1/rooms', this.roomInfo).then(async response => {
              await this.getRooms()
              snackbarOpen('info', `${this.roomInfo.name} 회의실이 수정되었습니다.`, 'info')
            }).catch(error => {
              console.log(error)
            })
          } else {
            snackbarOpen('pink', '잘못된 회의실 관리자 입니다.', 'error')
            return
          }
        }

        this.roomDialog.dialog = false
      },
      async confirmDialogClose (result) {
        if (result === 'ok') {
          let tableRefresh = false
          this.loading = true
          let url = '/api/v1'
          switch (this.confirmDialog.mode) {
            case 'building':
              url += `/buildings/${this.buildingInfo._id}`
              break
            case 'type':
              url += `/types/${this.typeInfo._id}`
              break
            case 'room':
              url += `/rooms/${this.roomInfo._id}`
              tableRefresh = true
              break
          }

          this.$http.delete(url).then(async response => {
            const prefix = this.confirmDialog.mode === 'building'
              ? '건물'
              : this.confirmDialog.mode === 'type'
                ? '유형'
                : '회의실'
            snackbarOpen('pink', `${prefix}이 삭제되었습니다.`, 'error')
            if (tableRefresh) {
              await this.getRooms()
            } else {
              await this.getTreeView()
            }
          }).catch(error => {
            console.log(url, error)
          })
          this.loading = false
        }
        this.confirmDialog.dialog = false
      },
      multiSelectChipChange (refName) {
        if (refName === 'userList') {
          this.searchReserveManagers = null
        }
      },
      chipClose (type, item) {
        if (type === 'reserve-admin') {
          const index = this.roomInfo.reserveManagers.findIndex(manager => manager.email === item.email)
          if (index > -1) {
            this.roomInfo.reserveManagers.splice(index, 1)
          }
        } else {
          this.roomInfo.roomManager = null
        }
      },
      searchPeople (type, val) {
        const search = val
        let searchLength = 4
        const check = /[ㄱ-ㅎ]|[ㅏ-ㅣ]|[가-힣]/
        if (check.test(search)) {
          searchLength = 2
        }
        // console.log('type :: ' + type)
        // console.log(check.test(search), search, searchLength)
        if (search === null || search === '' || search.length < searchLength) {
          // console.log('people clear')
          if (type === 'room') {
            this.peopleRoom = []
          } else {
            this.peopleReserve = []
          }
          return
        }
        this.searchUser(type, search.trim())
      },
      searchUser: debounce(async function (type, text) {
        await this.$http.get('/api/v1/organizations', { params: { search: text, limit: 100 } }).then(response => {
          if (type === 'room') {
            this.peopleRoom = response.data.splice(0, 100)
            // console.log('this.peopleRoom :: ' + JSON.stringify(this.peopleRoom))
          } else {
            this.peopleReserve = response.data.splice(0, 100)
            this.lastSearchPeople = [...this.peopleReserve]
            // console.log(this.lastSearchPeople)
          }
        }).catch(error => {
          console.log(error)
        })
      }, 200),
    },
  }
</script>

<style scoped>

</style>
